/** Lançamentos de contas a pagar no ERP (folha de pagamento e benefícios). */

export type StatusLancamentoErp = "criado" | "existente" | "divergente" | "erro";

export interface LancamentoErp {
  id: string;
  /** colaboradorId (folha) ou CNPJ do tomador (benefícios). */
  chave: string;
  nome: string;
  documento: string | null;
  tipoContrato: "PJ" | "CLT" | null;
  tomadorCnpj: string | null;
  /** Centavos — o valor que está no ERP. */
  valor: number;
  status: StatusLancamentoErp;
  contasPagarId: number | null;
  erro: string | null;
  avisos: string[] | null;
  dataVencimento: string | null;
  enviadoEm: string;
}

export interface ResumoErp {
  total: number;
  criados: number;
  existentes: number;
  divergentes: number;
  erros: number;
  comAvisos: number;
  ultimoEnvio: string | null;
}

export interface LancamentosErp {
  resumo: ResumoErp;
  /** Avisos do lote inteiro (ex.: total divergente). */
  avisosLote: string[];
  lancamentos: LancamentoErp[];
}

/** Retorno do fechamento/reenvio da folha: falha no ERP não desfaz o fechamento. */
export type ResultadoEnvioErp = ({ ok: true } & LancamentosErp) | { ok: false; mensagem: string };

/** Precisam de atenção de alguém: erro, valor divergente ou aviso do ERP. */
export const pendenciasErp = (lancamentos: LancamentoErp[] | undefined) =>
  (lancamentos ?? []).filter(
    (l) => l.status === "erro" || l.status === "divergente" || (l.avisos?.length ?? 0) > 0,
  ).length;
